import { useState, createContext, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import config from "../config.js";
import Loading from "../Components/Loading/Loading.jsx";
import { SessionExists } from "../Components/User/Session Exists/SesssionExists.jsx";
import { LanguageContext } from "./changeLanguageProvider";
import { serverLogout } from "../Utils/serverLogout.js";

const base_url = config.base_url;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const location = useLocation();
  const [userInfo, setUser] = useState(null);
  const [userType, setUserType] = useState();
  const [email, setEmail] = useState();
  const [user_id, setId] = useState();
  const [MFApermissions, setMFApermissions] = useState();
  const [PWDPermission, setPWDPermission] = useState();
  const [otp, setOTP] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState();
  const [webinar, setWebinar] = useState();
  const [login_data, setLoginData] = useState(false);
  const [awareness_email, setAwarenessEmail] = useState();
  const [sent_change_email, set_sent_change_email] = useState();
  const updateHash = (hash) => {
    window.sessionStorage.setItem("ostreon_hash", hash);
  };
  const hash = window.sessionStorage.getItem("ostreon_hash");

  useEffect(() => {
    if (
      location.pathname.startsWith("/login") &&
      !location.pathname.startsWith("/user")
    ) {
      setLoaded(true);
      return;
    }
    if (!location.pathname.startsWith("/user")) {
      setLoaded(true);
      return;
    }
    window.sessionStorage.setItem("ostreon_login", Date.now());
    fetch(base_url + "login", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then(async (res) => {
        if (res.status === 403) {
          setError(true);

          const loginData = await res.json();
          setLoginData(loginData);
          setLoaded(true);
        } else if (res.status === 200) {
          setError(false);
          return res.json();
        } else {
          console.log(`Login Status Code: ${res.status}`);
          return navigate("/login", { replace: true });
        }
      })
      .then((data) => {
        if (data.error) setUser();
        else {
          setUser(data.success);
          if (data.success.OTP === "true") {
            setWebinar(data?.success.webinar);
            login(true);
            setOTP(true);
            setUserType(data.success.type);
            setEmail(data.success.username);
            setId(data.success.user_id);
            setAwarenessEmail(data.success.awareness_email);
            set_sent_change_email(data.success.sent_change_email);
          } else setOTP(false);
          if (data.success.MFApermissions === true) {
            setMFApermissions(true);
          } else {
            setMFApermissions(false);
          }
          if (data.success.PWDpermission === true) {
            setPWDPermission(true);
          } else {
            setPWDPermission(false);
          }
        }
        setLoaded(true);
      })
      .catch((e) => {
        console.log(e);
        setLoaded(true);
      });
  }, [
    children?.props?.children.map((e) => {
      return e;
    }),
  ]);
  // }, [children])
  useEffect(() => {
    if (!location.pathname.startsWith("/user")) return;
    else {
      console.log("Updated");
      window?.Intercom("update", {
        email,
        user_id,
      });
    }
  }, [email, user_id]);

  const setPWDChange = (mode) => {
    window.sessionStorage.setItem("ostreon_forcePWD", mode);
  };
  const deletePWDChange = () => {
    window.sessionStorage.removeItem("ostreon_forcePWD");
  };
  // const [cookies, setCookie, removeCookie] = useCookies(['ostreon_auth']);
  const navigate = useNavigate();

  const logout = () => {
    window.sessionStorage.clear();
    setUser(null);
    setOTP(false);
    navigate("/login");
  };
  const login = (user) => {
    setUser(user);

    // userInfo={"username":xxx@xxx.xxx, "ostreon_key":XXXXXXX}
  };
  return (
    <AuthContext.Provider
      value={{
        userInfo,
        userType,
        otp,
        setOTP,
        login,
        logout,
        email,
        setEmail,
        user_id,
        setId,
        MFApermissions,
        setMFApermissions,
        PWDPermission,
        hash,
        updateHash,
        setPWDChange,
        error,
        awareness_email,
        setAwarenessEmail,
        set_sent_change_email,
        sent_change_email,
        webinar,
      }}
    >
      {loaded ? (
        login_data ? (
          <SessionExists
            login_data={login_data}
            login_time_text={dublicatedcontent?.login_time}
            device_text={dublicatedcontent?.device}
            title={dublicatedcontent?.you_have_been_logged_out}
            message={dublicatedcontent?.you_have_opened_session}
            onclick={() => {
              setLoginData(false);
              navigate("/login");
            }}
            button_message={dublicatedcontent?.dublicatedText3}
          />
        ) : (
          children
        )
      ) : (
        <Loading text={"Loading"} />
      )}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
